exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".recent-uploads {\n    margin: 0 auto;\n    max-width: 700px;\n    padding-top: 1rem;\n}\n\n.recent-upload-game {\n    display: flex;\n    justify-content: space-between;\n}\n\n.recent-upload-game .created-at {\n    color: #888;\n}\n", ""]);

